import type { VideoObjectData } from "~www/types/video-object";

function generateVideoObjectSchema(videoData: VideoObjectData) {
  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    contentUrl: videoData.contentUrl,
    description: videoData.description,
    duration: videoData.duration,
    embedUrl: videoData.embedUrl,
    name: videoData.name,
    regionsAllowed: videoData.regionsAllowed,
    thumbnailUrl: videoData.thumbnailUrl,
    uploadDate: videoData.uploadDate,
  };
}

export { generateVideoObjectSchema };
